export default {
  start: null,
  end: null,
  error: null,
};
